<template>
  <div class="col-md-6">
    <div>
      <input class="name" :value="value"
        @input="$emit('input', $event.target.value)"
        @keyup.enter="$emit('add')" type="text">
    </div>
    <div class="button">
      <button class="btn btn-complete" @click="$emit('add')">Créer</button>
      <button class="btn btn-danger" @click="$emit('cancel')">Annuler</button>
    </div>
    <hr>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
  export default {

    props: ["value"],

    mounted () {
      $('.name').focus()
    },

    computed: {
      ...mapState([ 'formError' ]),
      ...mapGetters([ 'anyError' ]),
    }

  }
</script>

<style lang="scss" scoped>
  div {
    position: relative;
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    li {
      line-height: 1.2rem;
    }
  }

  .name {
    font-size: 0.9rem;
  }

  .button {
    position: absolute;
    right: 0;
    bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/PersonnalPostalProxy/NewItem.vue